import styled from "styled-components";

import {
  alignItemsCenter,
  alpha,
  circle,
  fileAcceptAnimation,
  fileRejectAnimation,
  flexCenter,
  flexColumn,
  flexSpBetween,
  pseudo,
  rem,
} from "@styles/Utilities.styled";


export const StyledAnalysisPrescriptionDocumentsModalContent = styled.div`
  ${flexColumn}

  .files-wrapper {
    font-size: ${rem(14)};

    .uploaded-files {
      ul {
        ${flexColumn}
        gap: 0.5rem;
        margin-top: 1rem;

        li {
          ${flexSpBetween}
          gap: 1rem;
          padding: 0.5rem 1rem;
          border: 1px solid var(--clr-gray-175);
          border-radius: var(--border-radius-2);

          .content {
            ${alignItemsCenter}
            gap: 0.5rem;

            a {
              line-height: 1.2;
              transition: color 0.2s;

              &:hover {
                color: var(--clr-primary-400);
              }
            }

            svg {
              font-size: 1.5rem;
            }
          }
        }
      }
    }
  }
`;
